import React from "react";
import { Link } from "react-router-dom";
import BlogHeader from "./BlogHeader";
import BlogFooter from "./BlogFooter";
import "./Blog.css";
import "./BlogPostSafetyManager.css";

function BlogPostSafetyManager() {
  return (
    <div className="blog-wrap">
      <BlogHeader />
      <div className="blog-post-wrap">

        {/* Post header */}
        <div className="blog-post-header">
          <div className="blog-breadcrumb">
            <a href="/">현장통</a> › <Link to="/blog">현장가이드</Link> › <span>현장 운영</span>
          </div>
          <h1>안전관리자가 서류에 치이는 진짜 이유<br />— 그리고 하루를 되찾는 법</h1>
          <div className="blog-post-meta">
            <span className="meta-tag" style={{ background: "#d1fae5", color: "#065f46" }}>현장 운영</span>
            <span className="meta-tag" style={{ background: "#d1fae5", color: "#065f46" }}>안전관리자</span>
            <span>2026.06.05</span>
            <span>읽기 3분</span>
          </div>
        </div>

        {/* Article */}
        <article className="sm-article">

          {/* Hook */}
          <div className="sm-scene">
            <p className="sm-scene-time">오전 7시 30분. 현장 도착.</p>
            <p>TBM은 8시니까 30분 안에 준비해야 합니다.</p>
            <p>그런데 어제 못 다 쓴 위험성평가 기록이 있고, 이번 주 안전교육 일지도 반쯤 남아 있습니다. 협력사 서류 취합도 오늘까지입니다.</p>
            <p>이게 비정상인가 싶어서 동료한테 물어보면 돌아오는 답은 하나입니다.</p>
            <p className="sm-quote">"다 그래."</p>
          </div>

          {/* Section 1 */}
          <h2 className="sm-h2">서류가 많아서가 아닙니다</h2>

          <p>많은 안전관리자들이 "서류가 너무 많다"고 말합니다.</p>
          <p>맞는 말이지만, 그게 진짜 이유는 아닙니다.</p>

          <div className="sm-insight">
            <div className="sm-insight-label">진짜 문제</div>
            <p>기록하는 시간과 장소가 현장에 없다는 겁니다.</p>
          </div>

          <p>TBM은 현장에서 합니다. 안전점검도 현장에서 합니다.</p>
          <p>그런데 기록은 사무실에서 합니다.</p>
          <p>일어난 일과 기록하는 시점이 분리되어 있으니, 매번 기억을 되살려 써야 합니다. 자연히 밀립니다.</p>
          <p>밀린 서류는 퇴근 후로 넘어갑니다. 퇴근 후 서류는 다음 날 아침으로 넘어갑니다.</p>

          {/* Section 2 */}
          <h2 className="sm-h2">법정 서류만 몇 종인지 아세요?</h2>

          <p>건설현장 안전관리자가 챙겨야 하는 법정 서류는 기본 20종이 넘습니다.</p>
          <p>여기에 TBM 일지, 안전점검 기록, 교육 일지, 위험성평가 결과, 작업계획서까지 더하면 하루에 채워야 할 양식이 10개를 넘는 날도 생깁니다.</p>

          <div className="sm-stat-row">
            <div className="sm-stat">
              <div className="sm-stat-num">20<span>종+</span></div>
              <div className="sm-stat-label">건설현장 법정 서류</div>
            </div>
            <div className="sm-stat">
              <div className="sm-stat-num">3<span>시간</span></div>
              <div className="sm-stat-label">하루 평균 서류 작업 시간</div>
            </div>
            <div className="sm-stat">
              <div className="sm-stat-num">퇴근<span>후</span></div>
              <div className="sm-stat-label">서류 마무리하는 시간대</div>
            </div>
          </div>

          <p>이걸 다 현장 끝나고 책상에서 쓰고 있으면, 퇴근이 몇 시가 될지 모릅니다.</p>

          {/* Section 3 */}
          <h2 className="sm-h2">구조를 바꿔야 합니다</h2>

          <p>해결책은 의외로 단순합니다.</p>

          <div className="sm-principle">
            현장에서 일어나는 일은<br />현장에서 바로 기록한다.
          </div>

          <p>TBM 끝나고 30초. 안전점검 돌다가 이상한 것 발견하면 그 자리에서 사진 찍고 메모. 교육 끝나면 참석자 확인하고 바로 저장.</p>
          <p>이게 쌓이면 퇴근 후 서류 작업이 거의 없어집니다.</p>
          <p>기록이 현장에서 실시간으로 생기니까요.</p>

          {/* Section 4 - 현장통 자연 언급 */}
          <h2 className="sm-h2">현장통 쓰는 분들이 공통으로 하는 말</h2>

          <div className="sm-testimonial">
            <p className="sm-testimonial-text">"처음엔 앱 하나 더 배워야 한다는 게 부담이었어요. 근데 막상 써보니 TBM 기록이 3분도 안 걸리더라고요. 예전엔 그게 30분이었는데."</p>
            <p className="sm-testimonial-author">경기도 건설현장 안전관리자</p>
          </div>

          <p>스마트폰으로 현장에서 바로 TBM, 안전점검, 위험성평가를 기록하면 본사에서 실시간으로 확인할 수 있습니다.</p>
          <p>법적 증빙에 필요한 <strong>일시, 장소, 참여자</strong>가 자동으로 남습니다.</p>

          {/* CTA */}
          <div className="sm-cta">
            <div className="sm-cta-question">오늘 퇴근을 한 시간 앞당길 수 있다면?</div>
            <p>서류 때문에 늦게 퇴근하는 날이 얼마나 되시나요?</p>
            <p>현장통 무료체험으로 직접 확인해보세요.<br />설치부터 첫 TBM 기록까지 10분이면 됩니다.</p>
            <div className="sm-cta-buttons">
              <a href="/#contact" className="sm-cta-btn primary">
                무료체험 문의하기 →
              </a>
              <Link to="/blog/serious-accident-law" className="sm-cta-btn secondary">
                중대재해처벌법 완전 가이드 읽기
              </Link>
            </div>
          </div>

          {/* Tags */}
          <div className="blog-tags">
            {["#안전관리자", "#건설현장안전", "#TBM", "#위험성평가", "#안전서류", "#현장통", "#안전관리앱", "#건설안전"].map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>

          {/* Related */}
          <div className="blog-related">
            <h3>다음으로 읽으면 좋은 글</h3>
            <div className="related-grid">
              <Link to="/blog/serious-accident-law" className="related-card">
                <div className="related-card-tag">법규 가이드</div>
                <div className="related-card-title">중대재해처벌법 건설사 실무 대응 가이드 [2026년]</div>
              </Link>
              <Link to="/blog/risk-assessment-5steps" className="related-card">
                <div className="related-card-tag">현장 운영</div>
                <div className="related-card-title">이번 달 위험성평가, 빠진 항목 없이 끝내는 5단계</div>
              </Link>
              <Link to="/blog/tbm-no-record" className="related-card">
                <div className="related-card-tag">현장 운영</div>
                <div className="related-card-title">TBM 매일 하는데 왜 기록이 없나 — 현장소장의 현실</div>
              </Link>
            </div>
          </div>

        </article>

        {/* Footer */}
        <BlogFooter />

      </div>
    </div>
  );
}

export default BlogPostSafetyManager;
